import React from 'react';
import { useTranslate } from '../../mixins/translate/translate';
import { codeToColorCode } from '../../utils/conditionHelper';
import { PanelHeading, PanelLink } from '../elements';
import { GenericMap, IMarker } from '../utils/GenericMap';

const defaultZoom = 15;

export function ObjectDetailsAreaMap(props: {
    objectId: string;
    latitude: number;
    longitude: number;
    name: string;
    shapeGeoJson: string | undefined;
    surveyCondition?: undefined | string;
    surveyInspectionStandardType?: undefined | string;
    objectTypeName: string;
    isPdokMapLayerAvailable: boolean;
    isDroneNoFlyMapNlAvailable: boolean;
}) {
    const translate = useTranslate();

    const objectMarker: IMarker = {
        key: '0',
        position: { lat: props.latitude, lng: props.longitude },
        title: props.name ?? '',
        color: codeToColorCode(props.surveyCondition, props.surveyInspectionStandardType),
        shapeGeoJson: props.shapeGeoJson ? JSON.parse(props.shapeGeoJson) : undefined,
        isTerrain: props.objectTypeName?.toLowerCase() === 'terrein' || props.objectTypeName?.toLowerCase() === 'terrain',
    };

    return (
        <div className="panel" id="areamap">
            <PanelHeading text={translate('object.areaMap')} icon="fa fa-map-marker">
                {props.shapeGeoJson && (
                    <PanelLink
                        href={`/api/objects/${props.objectId}/shapeFile`}
                        text={translate('object.exportShape')}
                        isDownload={true}
                        icon="fa fa-download"
                        small={true}
                    />
                )}
            </PanelHeading>
            <div className="panel-body pn">
                <GenericMap
                    zoom={defaultZoom}
                    inLine={true}
                    center={{ lat: props.latitude, lng: props.longitude }}
                    isPdokMapLayerAvailable={props.isPdokMapLayerAvailable}
                    isDroneNoFlyMapNlAvailable={props.isDroneNoFlyMapNlAvailable}
                    markers={[objectMarker]}
                />
            </div>
        </div>
    );
}
